module.exports = __webpack_public_path__ + "img/waiting2.171491c3.svg";